import React from 'react'
import { Link } from 'react-router-dom'
import { Badge } from 'reactstrap'

// Column definitions for Admin Class List
export const adminClassColumns = (layout, role = 'admin') => [
	{
		name: 'ID',
		selector: (row) => row.id,
		sortable: true,
		start: true,
		width: '10%'
	},
	{
		name: 'Class Name',
		selector: (row) => row.class_name,
		sortable: true,
		center: false,
		width: '30%'
	},
	{
		name: 'Grade',
		selector: (row) => row.grade,
		sortable: true,
		center: true,
		width: '10%'
	},
	{
		name: 'Status',
		selector: (row) => row.isActive,
		sortable: true,
		center: true,
		width: '10%',
		cell: (row) => <Badge color={row.isActive ? 'success' : 'danger'}>{row.isActive ? 'Active' : 'Inactive'}</Badge>
	},
	{
		name: 'Actions',
		selector: (row) => row.actions,
		sortable: false,
		center: true,
		width: '40%',
		cell: (row) => (
			<div className="d-flex flex-column flex-sm-row gap-1 justify-content-center">
				<Link to={`${process.env.PUBLIC_URL}/${role}/class-management/add-student/${row.id}/${layout}`} className="btn btn-primary btn-sm">
					Add Students
				</Link>
				<Link to={`${process.env.PUBLIC_URL}/${role}/class-management/edit/${row.id}/${layout}`} className="btn btn-success btn-sm">
					<i className="fa fa-edit me-1"></i>
				</Link>
				<button className="btn btn-danger btn-sm" onClick={() => row.onDelete(row.id)}>
					 <i className="fa fa-trash"></i>
				</button>
			</div>
		)
	}
]

// Column definitions for Instructor Class List
export const instructorClassColumns = (layout, role = 'instructor') => [
	{
		name: 'Class Name',
		selector: (row) => row.class_name,
		sortable: true,
		center: false,
		width: '25%'
	},
	{
		name: 'Instructor',
		selector: (row) => `${row.name || ''} ${row.surname || ''}`,
		sortable: true,
		center: true,
		width: '15%'
	},
	{
		name: 'Students',
		selector: (row) => row.students,
		sortable: false,
		center: false,
		width: '40%',
		cell: (row) => (
			<div className="d-flex flex-wrap gap-2">
				{row.students &&
					row.students.map((student) => (
						<Link
							key={student.id}
							to={`${process.env.PUBLIC_URL}/${role}/student-tasks/${student.studentId}/${layout}`}
							className="badge bg-secondary text-decoration-none p-2"
						>
							{student.studentName}
						</Link>
					))}
			</div>
		)
	},
	{
		name: 'Actions',
		selector: (row) => row.actions,
		sortable: false,
		center: true,
		width: '20%',
		cell: (row) => (
			<div className="d-flex justify-content-center">
				<button className="btn btn-primary btn-sm" onClick={() => row.onMoreClick(row)}>
					More...
				</button>
			</div>
		)
	}
]
